import { create } from 'zustand';

interface NotificationStoreState {
  notification: any;
  handleNotification: (channel: any, message: any) => void;
  clearNotification: () => void;
  reconnectTimeoutInMinutes: number;
  logConnectionTime: () => void;
  lastConnectionTime: () => number | null;
}

export const useNotificationStore = create<NotificationStoreState>((set) => ({
  reconnectTimeoutInMinutes: 10,
  logConnectionTime: () => {
    localStorage.setItem('lastNotificationConnection', Date.now().toString());
  },
  lastConnectionTime: () => {
    const time = localStorage.getItem('lastNotificationConnection');
    return time ? parseInt(time, 10) : null;
  },
  notification: {},
  handleNotification: (channel: any, message: any) => {
    console.log(channel, message);
    set((state) => ({
      ...state,
      notification: { channel, message },
    }));
  },
  clearNotification: () => {
    set({ notification: {} });
  },
}));
